import React, { forwardRef, useEffect, useRef, useState } from "react";
import { Sandpack } from "@codesandbox/sandpack-react";
import { FiTarget } from "react-icons/fi";
import { CiCircleInfo } from "react-icons/ci";
import { Canvas } from "@react-three/fiber";
import Cube from "./Helper/Cube";
import { Stats, OrbitControls } from "@react-three/drei";
import { FaRegFaceSmileWink } from "react-icons/fa6";
import Sandpack_E2 from "./Sandpack_E2";
import { GoArrowLeft } from "react-icons/go";
import { FaFlagCheckered } from "react-icons/fa";
import { AiOutlineCheck } from "react-icons/ai";

function E2() {
    const [viewportHeight, setViewportHeight] = useState(0);
    const [seeTarget, setSeeTarget] = useState(false);
    const [seeInstructions, setSeeInstructions] = useState(false);
    const buttonRef = useRef(0);

    const handleButtonClick = () => {
        alert("Render Evaluatin Coming Soon");
        unHideElements();
    };

    const hideElements = () => {
        const elements = document.querySelectorAll(".disappear_text");
        console.log(elements);
        elements.forEach((element) => {
            element.classList.add("hidden");
        });
    };

    const unHideElements = () => {
        const elements = document.querySelectorAll(".disappear_text");
        console.log(elements);
        elements.forEach((element) => {
            element.classList.remove("hidden");
        });
        setTimeout(hideElements, 5000);
    };


    useEffect(() => {
        buttonRef.current = 0;
        const updateViewportHeight = () => {
            const heightInPixels = window.innerHeight;
            setViewportHeight(heightInPixels);
        };

        updateViewportHeight();
        window.addEventListener("resize", updateViewportHeight);
        // Call the function after 5 seconds
        setTimeout(hideElements, 5000);
        return () => {
            window.removeEventListener("resize", updateViewportHeight);
        };
    }, []);

    return (
        <div>
            <div className="sandpack_container_full">
                <Sandpack_E2 />
            </div>
            {seeTarget ? (
                <div className="e2_canvas">
                    <Canvas>
                        <ambientLight />
                        <pointLight position={[10, 10, 10]} />
                        <Cube />
                        <OrbitControls />
                    </Canvas>
                </div>
            ) : null}

            {seeInstructions ? (
                <div className="e2_canvas">
                    <div>Instructions</div>
                    <div>Get a Cube to rotate along the X Axis</div>
                    <div>Guide <a target="_blank" href="https://medium.com/@jerryjohnthomas/threejs-react-ep-01-mesh-f335317338f6">here</a></div>
                </div>
            ) : null}

            <div className="buttons_container">
                <div className=" extra_button target_button" onClick={() => setSeeTarget((x) => !x)}>
                    <FiTarget /> <GoArrowLeft className="disappear_text disappear_icon" /> <div className="disappear_text">See Target Render</div>
                </div>
                <div className="extra_button info_button" onClick={() => setSeeInstructions((x) => !x)}>
                    <CiCircleInfo /> <GoArrowLeft className="disappear_text disappear_icon" /> <div className="disappear_text">Lesson Instructions</div>
                </div>
                <div ref={buttonRef} value={0} className="extra_button info_button" onClick={handleButtonClick}>
                    <AiOutlineCheck />
                     <GoArrowLeft className="disappear_text disappear_icon" /> <div className="disappear_text">Eval Submission (Coming Soon)</div>
                </div>
            </div>
        </div>
    );
}

export default E2;
